<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue'
import i18n from '@/lang/i18n';

const props = defineProps<{
  label: string
  permissionName: string
  modelValue: string[]
  actionList: string[]
}>()
const emits = defineEmits(['update:modelValue'])

const labelSuffix = ref("")

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

type checkboxStatusType = {
  [key: string]: boolean;
}
const allCheckboxStatus = ref(false);
const checkboxStatus = ref<checkboxStatusType>({
  "read": false,
  "create": false,
  "update": false,
  "delete": false,
  "output": false,
  "input": false,
})

onMounted(() => {
  setCheckboxStatus()
  checkActionLabel()
})
watch(() => props.modelValue, () => {
  setCheckboxStatus()
})
function setCheckboxStatus(){
  initCheckbox()
  if(!modelValue.value) return
  modelValue.value.forEach( (action) => {
    checkboxStatus.value[action] = true
  })
  switchAllCheckboxStatus()
}

function checkActionLabel(){
  if(props.permissionName == 'daily_report') {
    labelSuffix.value = i18n.global.t('pages.userRoles.form.permissionItems.dailyReport.suffix')
  }
}

function initCheckbox(){
  checkboxStatus.value = {
    "read": false,
    "create": false,
    "update": false,
    "delete": false,
    "output": false,
    "input": false,
  }
  allCheckboxStatus.value = false;
}

function getVisibilityStatus(label:string, actions:string[]){
  let class_name = ""

  if(!actions.includes(label)){
    class_name="hidden-checkbox"
  }
  return class_name
}

function clickAllCheckbox(){
  let status = false
  if(allCheckboxStatus.value){
    status = true
  }
  props.actionList.map((action) => {
      checkboxStatus.value[action] = status
  })
  updateModelValue()
}

function switchAllCheckboxStatus(){
  const falseStatuses = Object.entries(checkboxStatus.value).filter(([key, value]) => {
    return props.actionList.includes(key) && !value
  })
  if(Object.keys(falseStatuses).length) {
    allCheckboxStatus.value = false;
  }else{
    allCheckboxStatus.value = true;
  }
}

function updateModelValue(){
  let new_actions = [] as string[]
  Object.keys(checkboxStatus.value).forEach( (action) => {
    if(checkboxStatus.value[action]) new_actions.push(action)
  })
  modelValue.value = new_actions
}

function switchCheckboxStatus(){
  switchAllCheckboxStatus()
  updateModelValue()
}

</script>
<template>
  <div class="permission-item-area">
    <v-label
      :text="props.label"
      class="permission-name"
    />
    <div class="checkbox-area d-flex">
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.all')"
        v-model="allCheckboxStatus"
        @change="clickAllCheckbox()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.read')"
        :class="getVisibilityStatus('read', actionList)"
        v-model="checkboxStatus['read']"
        @change="switchCheckboxStatus()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.create') + labelSuffix"
        :class="getVisibilityStatus('create', actionList)"
        v-model="checkboxStatus['create']"
        @change="switchCheckboxStatus()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.update')"
        :class="getVisibilityStatus('update', actionList)"
        v-model="checkboxStatus['update']"
        @change="switchCheckboxStatus()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.delete') + labelSuffix"
        :class="getVisibilityStatus('delete', actionList)"
        v-model="checkboxStatus['delete']"
        @change="switchCheckboxStatus()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.output')"
        :class="getVisibilityStatus('output', actionList)"
        v-model="checkboxStatus['output']"
        @change="switchCheckboxStatus()"
      />
      <v-checkbox
        :label="i18n.global.t('pages.userRoles.form.action.input')"
        :class="getVisibilityStatus('input', actionList)"
        v-model="checkboxStatus['input']"
        @change="switchCheckboxStatus()"
      />
    </div>
  </div>
  <v-divider class="my-4"></v-divider>

</template>
<style scooped>
.permission-item-area{
  display: flex;
  flex-direction: column;
}
.permission-name{
  font-size: 1.2rem;
  color: #000000;
  font-weight: bold;
}
.hidden-checkbox{
  visibility: hidden;
}
</style>